<template>
  <main>
    <div class="container">
      <div class="page_content" v-html="htmlContent" />
      <template v-for="promotion in promotions" :key="`title-${promotion.id}`">
        <h2 class="text-black">{{ promotion.title }}</h2>
        <div class="page_content">
          <p v-html="promotion.description"></p>
        </div>
      </template>
    </div>
  </main>
</template>

<script setup lang="ts">
import type { IPromotionsPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IPromotionsPage>('page-promotion', {
  populate: 'deep',
});

const data = response.data as unknown as IPromotionsPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;

const promotionsStore = usePromotionsStore();

onMounted(() => {
  promotionsStore.getAll();
});

const promotions = promotionsStore.data;
</script>

<style lang="scss" scoped>
h2 {
  font-family: "Cormorant", serif;
  font-size: 26px;
  font-weight: 600;
}
</style>
